<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <addHeader
          :title="$t('Create Section')"
          :description="$t('From Here You Can Create A New Product Section')"
          v-if="$route.name == 'sectionsCreate'"
        />
        <addHeader
          :title="$t('Edit section')"
          :description="$t('From Here Modify The Section Data')"
          v-if="$route.name == 'sectionsEdit'"
        />
        <div class="mb-4 row">
          <dvider
            :title="$t('Section Information')"
            :description="$t('Basic Section Information')"
            noLine="true"
          />
          <fileInput
            :title="$t('Classification Picture')"
            v-model="item.image"
            :image="item.image"
            :path="'sections'"
            :hasErorr="errors.image"
            :error="$t('Choose A SuitableFile')"
            :col="'col-12'"
          />
          <formInput
            :title="$t('Section Name')"
            v-model="item.name"
            :hasErorr="errors.name"
            :error="$t('This field Is required')"
          />
          <connectionInput
            :title="$t('father Section')"
            :group="$t('sections')"
            v-model="item.parent_id"
            :hasAdd="false"
            :values="$database.sections"
          />
          <div class="form-group col-md-6 row">
            <label class="col-md-4">{{ $t('classification Icon') }}</label>
            <div class="col-md-7">
              <select type="text" class="form-control" v-model="item.icon">
                <option value="">{{ $t('choose Icon') }}</option>
                <option v-for="(icon, index) in icons" :key="index">
                  {{ icon }}
                </option>
              </select>
            </div>
          </div>
          <!-- Divider -->
          <hr class="mt-5 mb-5 col-12" />
          <!-- Buttons -->
          <a
            @click="saveItem"
            class="btn btn-block btn-primary"
            v-if="$route.name == 'sectionsCreate' && !$parent.stopEdit"
          >
            {{ $t('create Section') }}
          </a>
          <a
            @click="saveItem"
            class="btn btn-block btn-primary"
            v-if="$route.name == 'sectionsEdit' && !$parent.stopEdit"
          >
            {{ $t('edit Section') }}
          </a>
          <loading v-if="$parent.stopEdit" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'

import formInput from '@/elements/add/form/formInput.vue'
import fileInput from '@/elements/add/form/fileInput.vue'
import connectionInput from '@/elements/add/form/connectionInput.vue'
import dvider from '@/elements/add/dvider.vue'
import addHeader from '@/elements/add/header.vue'
import loading from '@/elements/add/loading.vue'
export default {
  data() {
    return {
      path: '/sections',
      item: {},
      sections: {},
      errors: {
        name: false
      },
      icons: [
        'cake',
        'capuccino',
        'cauliflower',
        'cola',
        'crepe',
        'cup-of-drink',
        'dessert',
        'donut',
        'drink',
        'ezgif.com-gif-maker',
        'fast-food',
        'fish',
        'food ',
        'french-fries',
        'meat',
        'milk',
        'pasta',
        'pizza',
        'roast-chicken',
        'salad',
        'salt',
        'sandwich',
        'shrimp',
        'skewer',
        'sugar',
        'tea',
        'vegetables',
        'waffle'
      ]
    }
  },
  methods: {
    getItem() {
      axios.get(this.$linkGenerator(this.path + '/' + this.$route.params.id)).then((response) => {
        this.item = response.data
        this.$parent.stopEdit = false
      })
    },
    saveItem() {
      var error = 0
      if (typeof this.item.name === 'undefined' || this.item.name == '') {
        error = 1
        this.errors.name = true
      }
      if (error == 0) {
        if (this.$route.name == 'sectionsCreate') {
          this.$parent.aletText = this.$t('section Successfully Added')
          this.$parent.alertType = 'success'
          this.$addToLocalDatabase(this.item, this.path.substring(1))
          this.$router.go(-1)
        } else if (this.$route.name == 'sectionsEdit') {
          this.item._method = 'PUT'
          this.$parent.stopEdit = true
          axios
            .post(this.$linkGenerator(this.path + '/' + this.item.id), this.item)
            .then((response) => {
              this.$parent.aletText = this.$t('section Has Been Modified Successfully')
              this.$parent.alertType = 'success'
              this.$router.go(-1)
              this.$parent.stopEdit = false
              return response
            })
        }
      } else {
        this.$parent.aletText = this.$t('please Make Sure Of The Input')
        this.$parent.alertType = 'danger'
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      }
    }
  },
  mounted() {
    this.$updateDatabase(['sections'])

    if (this.$route.name == 'sectionsEdit') {
      this.$parent.stopEdit = true
      this.getItem()
    }
  },
  components: {
    formInput,
    fileInput,
    dvider,
    addHeader,
    connectionInput,
    loading
  }
}
</script>
<style></style>
